Date.getTZString = function (offset) {
    switch (offset) {
        case -660:
            return "Pacific/Midway";
        case -600:
            return "America/Adak";
        case -570:
            return "Pacific/Marquesas";
        case -540:
            return "America/Anchorage";
        case -480:
            return "America/Dawson";
        case -420:
            return "America/Boise";
        case -360:
            return "America/Bahia_Banderas";
        case -300:
            return "America/Atikokan";
        case -270:
            return "America/Caracas";
        case -240:
            return "America/Anguilla";
        case -210:
            return "America/St_Johns";
        case -180:
            return "America/Araguaina";
        case -120:
            return "America/Noronha";
        case -60:
            return "America/Scoresbysund";
        case 0:
            return "UTC";
        case 60:
            return "Africa/Algiers";
        case 120:
            return "Africa/Blantyre";
        case 180:
            return "Africa/Addis_Ababa";
        case 210:
            return "Iran";
        case 240:
            return "Asia/Baku";
        case 270:
            return "Asia/Kabul";
        case 300:
            return "Antarctica/Davis";
        case 330:
            return "Asia/Calcutta";
        case 345:
            return "Asia/Kathmandu";
        case 360:
            return "Antarctica/Vostok";
        case 390:
            return "Asia/Rangoon";
        case 420:
            return "Asia/Bangkok";
        case 480:
            return "Asia/Brunei";
        case 510:
            return "Asia/Pyongyang";
        case 525:
            return "Australia/Eucla";
        case 540:
            return "Asia/Dili";
        case 570:
            return "Australia/Adelaide";
        case 600:
            return "Antarctica/DumontDUrville";
        case 630:
            return "Australia/LHI";
        case 660:
            return "Antarctica/Casey";
        case 690:
            return "Pacific/Norfolk";
        case 720:
            return "Antarctica/McMurdo";
        case 765:
            return "Pacific/Chatham";
        case 780:
            return "Pacific/Apia";
        case 840:
            return "Pacific/Kiritimati";

        default:
            return "";
    }
};

Date.prototype.isToday = function () {
    return moment(this).isSame(new Date(), "day");
};
